<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters" />
          <Headerlayout :headertext="$t('ItemCategory.ItemCategoryMaster.List')" :contenttext="$t('ItemCategory.ItemCategoryMaster.TableHeaderContent')
            " />
        </b-col>
      </b-row>

      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Category Master" econtent="Category Master"
              eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <div class="">
              <Tableview :value="items" v-if="items.length != 0" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                :columns="headers" @row-click="RowClick" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single" :exceldownload="true">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsAdd()" class="float-rights my-3" :btnname="$t('btn.plusaddnew')"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Category Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:group="{ data }">
                  <p @click="
                    navigatetopage('groupTableview', data.groupCount, data)
                    ">
                    {{ data.groupCount }}
                  </p>
                </template>
                <template v-slot:Status="{ data }">
                  <!-- <Badge v-if="data.Status == '0'" severity="warning">{{
                    "InActive"
                  }}</Badge>
                  <Badge v-if="data.Status == '1'" severity="success">{{
                    "Active"
                  }}</Badge> -->
                  <OrangeStatus name="InActive" v-if="data.Status == '0'" />
                  <GreenStatus name="Active" v-if="data.Status == '1'" />
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Category Master" econtent="Category Master"
              eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.Code }}</p>
                      <div class="d-flex align-items-center">
                        <p class="name1">{{ item.Name }}</p>
                        <p class="name2">({{ item.Prefix }})</p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <!-- <Badge v-if="item.Status == '0'" severity="warning">{{
                          "InActive"
                          }}</Badge>
                        <Badge v-if="item.Status == '1'" severity="success">{{
                          "Active"
                          }}</Badge> -->
                        <OrangeStatus name="InActive" v-if="item.Status == '0'" />
                        <GreenStatus name="Active" v-if="item.Status == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Group :</p>
                    <p class="small-name">{{ item.groupCount }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>

        <CategoryCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
          @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>
    </b-container>
  </div>
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="Isdelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <Toast />
</template>

<script lang="ts">
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import CategoryCreation from "../../../Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import CategoryService from "../../../../../../modules/Inventory/Service/CategoryService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteIcon from "../../../../../../components/GeneralButtons/DeleteIcon.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    DeletedSuccessfully,
    DeleteConfirmationVue,
    EditConfirmation,
    BacktoPage,
    Headerlayout,
    CategoryCreation,
    Tableview,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },

  setup() {
    const toast = useToast();
    let route = useRouter();
    const showDialog = ref(false);
    const dataEdit = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let MappingPopup = ref(false);
    let loading1 = ref(false);
    let loading = ref(false);

    const router = useRoute();
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    let ContentName = ref("");

    let delId = 0;
    let items: any = ref([]);

    let storeId = router.query.storeId;

    const MappingPop = ref({
      visible: false,
      content: "",
    });

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    function IsAdd() {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    const contentdel = ref("");
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      document.addEventListener("keydown", onKeyUp);
      window.addEventListener("resize", handleResize);
      if (storeId) {
        categorybasedonstore();
      } else {
        IsShow();
      }

      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        Isdelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }

    //Table column List
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Prefix: { value: null, matchMode: FilterMatchMode.IN, options: items },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
      groupCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    function navigatetopage(pagename, datacount, datas) {
      if (datacount != 0) {
        route.push({
          name: pagename,
          path: "/" + pagename,
          query: {
            categoryId: datas.Id,
          },
        });
      } else {
        alert("Somthing went wrong");
      }
    }
    const headers = [
      {
        header: t('ItemCategory.ItemCategoryMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('ItemCategory.ItemCategoryMaster.Code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t('ItemCategory.ItemCategoryMaster.Prefix'),
        field: "Prefix",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth"
      },
      {
        header: t('ItemCategory.ItemCategoryMaster.Name'),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth"
      },
      {
        header: t('ItemCategory.ItemCategoryMaster.Group'),
        field: "groupCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "group",
        fieldDisplay: "false",
        bodyclass: "bluecolor right_td",
        class: "smallwidth"
      },
      {
        header: t('ItemCategory.ItemCategoryMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));


    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await CategoryService.getdata();
        console.log(response["result"]);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.Status == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }


    //IsShow function
    const IsShow = async () => {
      loading.value = true;
      try {
        debugger;
        const response = await CategoryService.getdata();
        console.log(response["result"]);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.Status == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });

        items.value = response["result"];
        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }

    //categorydelete function
    const Isdelete = async (data) => {
      loading.value = true;
      try {
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await CategoryService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await CategoryService.active(data.Id, status);
        }
        let message = response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = response["result"];
          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;
      if (data.Status == 0) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }
      menu.value.toggle(event);
    };

    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 2);
            },
          },
        ],
      },
    ]);

    async function categorybasedonstore() {
      loading.value = true;
      try {
        debugger;
        let response = await ItemStoreMappingService.StoreCategoryMappingget(
          router.query.storeId, usersData.BranchId
        );
        response["result"] = response["result"].map((item) => {
          item.ActiveStatus = item.Status == 1 ? "Active" : "Inactive";
          return item;
        });
        const oldKey1 = "CategoryName";
        const newKey1 = "Name";

        items.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
          };
          delete newItem[oldKey1];

          return newItem;
        });

        loading.value = false;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      ObjOperationId,
      navigatetopage,
      contentdel,
      pop,
      MappingPop,
      toggle,
      menu,
      itemListed,
      onKeyUp,
      IsAdd,
      RowClick,
      dataEdit,
      Editmodel,
      IsEdit,
      IsConfirmEdit,
      IsConfirmDel,
      showDialog,
      editItems,
      closetrigger,
      deletepop,
      Deletemodel,
      IsShow,
      Isdelete,
      headers,
      items,
      filters,
      globalFilterFields,
      filteredColumns,
      loading1,
      loading,
      MappingPopup,
      ContentName,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      EntityData
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategory {
  font-size: 16px;
  font-weight: 500;
}

.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
